export default {
    primary: {
        main: "#ffeb3b",
        light: "#ffee58",
        contrastText: "#212121"
    }
}